import {
  GET_TYPE_NOTES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_TYPE_NOTES,
  UPDATE_TYPE_NOTES,
  DELETE_TYPE_NOTES,
} from './actionType';

const INIT_STATE = {
  typeNotes: [],
  error: {},
  successTypeNotes: '',
};

const TypeNotes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TYPE_NOTES:
          return {
            ...state,
            typeNotes: action.payload.data,
            successTypeNotes: '',
            error: {},
          };
        case CREATE_TYPE_NOTES:
          return {
            ...state,
            successTypeNotes: 'Successfully created',
            error: {},
          };
        case UPDATE_TYPE_NOTES:
          return {
            ...state,
            successTypeNotes: 'Successfully updated',
            error: {},
          };
        case DELETE_TYPE_NOTES:
          return {
            ...state,
            successTypeNotes: 'Successfully Deleted',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_TYPE_NOTES:
          return {
            ...state,
            successTypeNotes: '',
            error: action.payload.error,
          };
        case CREATE_TYPE_NOTES:
          return {
            ...state,
            successTypeNotes: '',
            error: action.payload.error,
          };
        case UPDATE_TYPE_NOTES:
          return {
            ...state,
            successTypeNotes: '',
            error: action.payload.error,
          };
        case DELETE_TYPE_NOTES:
          return {
            ...state,
            successTypeNotes: '',
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_TYPE_NOTES: {
      return {
        ...state,
      };
    }
    case CREATE_TYPE_NOTES: {
      return {
        ...state,
      };
    }
    case UPDATE_TYPE_NOTES:
      return {
        ...state,
      };
    case DELETE_TYPE_NOTES:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default TypeNotes;
